<template>
<div class="divSelectBorne">
    <h3 class="titre">Choisissez votre defipix</h3>
    <div class="listBorne">
        <div class="divBorne" v-for="(booth, index) in listBorne" :key="index" :id="'divBorne_'+booth.id">
            <div class="content" @click="selectborne(booth)">
                <img v-if="booth.name === 'Mini'" class="bestSeller" alt="option best seller" src="https://preprod.api.defipix.fr/logos/best_seller_contrast200.png" />
                <img class="illusBorne" :src="'https://preprod.api.defipix.fr/ressource/booth/picture/'+booth.picture" />
                <h5>Défipix {{ booth.name }}</h5>
                <p class="description">{{ booth.description }}</p> 
                <p id="aPartirDe">A partir de</p>
                <h4 v-if="$store.getters.reservation_client.client.typeClient === 'Particulier'">{{ booth.price }}€</h4>
                <h4 v-else-if="$store.getters.reservation_client.client.typeClient === 'Professionnel'">{{ (Number(booth.price)-Number(booth.price/5)).toFixed(2) }}€ HT</h4>
                <h5 style="color: green" v-if="dispoBorne[booth.name] >= 3 || booth.name == 'Miroir' && dispoBorne[booth.name] > 0">Disponible</h5>
                <h5 style="color: orange" v-else-if="dispoBorne[booth.name] >= 1 || booth.name != 'Miroir' && dispoBorne[booth.name] >= 1">Plus que quelques bornes disponibles</h5>
                <h5 style="color: red" v-else >Indisponible</h5>
            </div>
            <div style="height: 1em;">
                <span class="infoBtn" :id="'infoBtn_'+booth.id" @click="openBooth(booth.id)">Plus d'infos</span>
            </div>
        </div>
    </div>
    <NavBar :prev="true" />
</div>
</template>

<script>
import NavBar from '@/components/OrderBooth/NavBar'
import axios from 'axios';
import JQuery from 'jquery';
let $ = JQuery;

export default {
    data() {
        return {
            listBorne: [],
            dispoBorne: [],
        }
    },
    mounted: function () {
        $('html,body').animate({scrollTop: 0}, 'slow');
        this.getListBorne();
        this.getDispo();
    },
    updated() {
        $(".divBorne").each(function(i, val) {
            if( i%2 === 0) {
                $( this ).css("transform", "rotateZ(-4deg)");
            } else {
                $( this ).css("transform", "rotateZ(4deg)");
            }
            $( this ).hover(function() {
                $(`#infoBtn_${i+1}`).css('display', 'block');
                $( this ).css("transform", "rotateZ(0)");
                if( i%2 !== 0) {
                    $( this ).css("transform", "scale(1.1)");
                }
            }, function() {
                $(`#infoBtn_${i+1}`).css('display', 'none');
                if( i%2 === 0) {
                    $( this ).css("transform", "rotateZ(-4deg)");
                } else {
                    $( this ).css("transform", "scale(1)");
                    $( this ).css("transform", "rotateZ(4deg)");
                }
            })
        });
    },
    methods: {
        async getListBorne() {
            try {
                const response = await axios.get('https://preprod.api.defipix.fr/booth');
                response.data.sort(function(a,b) {
                    return a.id - b.id;
                });
                this.listBorne = response.data;                
            } catch (error) {
                console.error(error);
            }
        },
        async getDispo() {
            try {
                let date = new Date(this.$store.getters.reservation_client.evenement.date)
                let sqlDate = date.toISOString().substring(0, 10);
                const response = await axios.get(`https://preprod.api.defipix.fr/availability/findByDate/${sqlDate}`);
                const availability = {
                    'Ring': response.data.Ring + response.data.Ring_Retrait,
                    'Mini': response.data.Mini + response.data.Mini_Retrait,
                    'Miroir': response.data.Miroir,
                }
                this.dispoBorne = availability;
            } catch (error) {
                console.error(error);
            }
        },
        selectborne(borne) {
            if (!this.dispoBorne[borne.name]) {
                return;
            }
            if (borne.name != this.$store.getters.reservation_client.borne.name) {
                this.$store.commit('RCclearOptionList');
            }
            this.$store.commit('RCsetBorne', borne);
            this.$store.commit('RCetapeNext');
        },
        openBooth(id) {
            window.open(`./#/Booths?reservation=true&id=${id}`);
            window.focus();
        },
    },
    components: {
        NavBar
    }
}
</script>

<style scoped>

.divSelectBorne {
    margin-bottom: 2em;
    background-color: rgb(248, 248, 248);
    border-radius: 10px;
    padding-top: 2em;
    box-shadow: 0px 0px 5px 0px #aaa;
    background-color: #25327B;
}

.listBorne {
    display: grid;
    grid-template-columns: auto auto auto;
    grid-gap: 2em;
    width: fit-content;
    margin: auto;
    padding: 2em;
    perspective: 2000px;
}

.divBorne {
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.divBorne>.content {
    background-color: #f9f9f9;
    box-shadow: 0px 0px 5px 0px #444;
    text-align: center;
    margin: 0.5em auto;
    padding: .75em 0;
    border-radius: 5px;
    max-width: 20em;
}

.divBorne>*:hover {
    cursor: pointer;
    transform: scale(1.03);
    transform: rotateZ(0);
}

.infoBtn {
    display: none;
    text-align: center;
    color: #fff;
    width: fit-content;
    margin: auto;
}

h5, h4 {
    color: #25327B;
}

#aPartirDe {
    font-size: 0.9em;
    font-family: sans-serif;
    margin-bottom: 0;
}

.illusBorne {
    width: 90%;
    display: block;
    margin: 0 auto .5em auto;
    background-color: #25327B;
}

.description>span {
    color: #0070cd;
}

.description>span:hover {
    color: #f677c4;
    cursor: pointer;
}

.bestSeller {
    position: absolute;
    width: 6em;
    top: -2em;
    left: -2em;
    transform: rotateZ(-10deg);
}

@media only screen and (max-width: 1366px) {
    .infoBtn {
        display: block;
    }
}

@media only screen and (max-width: 680px) {
    .listBorne {
        display: block;
    }

    .divBorne {
        margin-bottom: 3em;
        padding: 0.25em;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/OrderBooth/Booth.vue